import { render, staticRenderFns } from "./LootGear.vue?vue&type=template&id=4d03db3e&lang=pug&"
import script from "./LootGear.vue?vue&type=script&lang=ts&"
export * from "./LootGear.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports